// src/App.js
import React from 'react';
import LandingPage from './Components/landingPage'
import './index.css'; // Ensure to import your CSS file here
import AboutUs from './Components/aboutUs';
import Footer from './Components/footer';
import Working from './Components/working';


function App() {
  return (
    <div>
      <LandingPage />
      <AboutUs />
      <Working/>
      <Footer />
     
    </div>
  );
}

export default App;
